import type { ApiDocument, ApiFolder } from "@workith/shared";
import { Card } from "@workith/ui";
import { FileText } from "lucide-react";
import type { ReactNode } from "react";
import { DocumentActions } from "./DocumentActions";
import { formatDocumentDate } from "./documentDisplay";

interface DocumentGridProps {
  documents: ApiDocument[];
  folders?: ApiFolder[];
  onOpenDocument: (document: ApiDocument) => void;
  renderBadge: (document: ApiDocument) => ReactNode;
  renderDescription?: (document: ApiDocument) => ReactNode;
  onDocumentUpdate?: () => void;
}

export function DocumentGrid({
  documents,
  folders = [],
  onOpenDocument,
  renderBadge,
  renderDescription,
  onDocumentUpdate,
}: DocumentGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {documents.map((documentItem) => (
        <Card key={documentItem.id} className="relative p-4 hover:shadow-md">
          <div className="flex items-start justify-between gap-2">
            <button
              type="button"
              className="flex min-w-0 flex-1 cursor-pointer flex-col gap-2 text-left"
              onClick={() => onOpenDocument(documentItem)}
              aria-label={`Open ${documentItem.name}`}
            >
              <FileText className="h-6 w-6 text-muted-foreground" />
              <h4 className="w-full truncate font-medium">{documentItem.name}</h4>
              {renderDescription ? (
                <p className="w-full truncate text-xs text-muted-foreground">
                  {renderDescription(documentItem)}
                </p>
              ) : null}
              <p className="text-xs text-muted-foreground">
                {formatDocumentDate(documentItem.updated_at)}
              </p>
            </button>
            <div className="flex shrink-0 items-center gap-1">
              {renderBadge(documentItem)}
              {onDocumentUpdate ? (
                <DocumentActions
                  document={documentItem}
                  folders={folders}
                  onUpdate={onDocumentUpdate}
                />
              ) : null}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
